import { AuthenticationState } from '../types';

export function getFullName(authenticationState: AuthenticationState) {
    return `${authenticationState.customer.individual.first_name} ${authenticationState.customer.individual.last_name}`;
}
